<script setup lang="ts">
// types
import type { SectionTestProps } from '@ts-sections/section-test/interfaces'
// hooks
import { useSectionTest } from '@hooks/sections/section-test.hook'
// components
import { SectionLayout } from '@UI/Layouts/SectionLayout'
import BlockTestPickerRow from '@Blocks/BlockTestPickerRow.vue'

defineOptions({
  name: 'SectionTest',
})

const props = defineProps<{
  section: SectionTestProps
}>()

const {
  refTitle,
  refDescription,
  refBackgroundColor,
  refIsSingle,
} = useSectionTest({
  section: () => props.section,
})
</script>

<template>
  <SectionLayout
    class="section-test"
    :data-component="section.__component"
    :title="refTitle"
    :title-tag="section.layout?.titleTag"
    :description="refDescription"
    :color="refBackgroundColor"
    :space="section.layout?.space"
  >
    <div class="section-test__panel">
      <ul
        class="section-test__grid"
        :class="{ 'section-test__grid--single': refIsSingle }"
      >
        <li
          v-for="(test, index) in section.tests"
          :key="test.id ?? index"
        >
          <BlockTestPickerRow :block="test" />
        </li>
      </ul>
    </div>
  </SectionLayout>
</template>

<style scoped lang="scss" src="@scss/components/Sections/SectionTest.scss" />
